// js
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import classnames from 'classnames';
// css
import '../../styles/components/common/FormattedGB.scss';


const FormattedGB = ({ className, value, perDay, labelStyle, valueStyle }) => (
  <span className={classnames('formatted-gb', className)}>
    <span className='formatted-gb__value' style={valueStyle}>
      <FormattedNumber
        value={value}
        maximumFractionDigits={1}
      />
    </span>&nbsp;
    <span className='formatted-gb__label' style={labelStyle}>
      GB{perDay ? '/day' : ''}
    </span>
  </span>
);

FormattedGB.defaultProps = {
  perDay: false
};

FormattedGB.propTypes = {
  className: PropTypes.string,
  value: PropTypes.number.isRequired,
  perDay: PropTypes.bool,
  labelStyle: PropTypes.object,
  valueStyle: PropTypes.object
};

export default FormattedGB;



// WEBPACK FOOTER //
// ./src/components/common/FormattedGB.js